//#region src/hooks/countryLabelKey.ts
var e = (e) => typeof e == "string" ? e.trim().toUpperCase() : "";
//#endregion
export { e as countryLabelKey };
